import ProfileDetails from "../features/Profile/ProfileDetails"
import SignIn from "../features/Auth/SignIn"
import ForgotPassword from "../features/ChangePassword/ForgotPassword"
import ResetPassword from "../features/ChangePassword/ResetPassword"
import Users from "../features/Users/Users"
import AdminDashboard from "../features/Dashboard/AdminDashboard"
import Tickets from "../features/Tickets/Tickets";
import ErrorDashboard from "../features/ErrorDashboard/ErrorDashboard"
import AuditLogs from "../features/AuditLogs/AuditLogs";
import TeamUpdate from "../features/TeamUpdate/TeamUpdate"
import { VenueUpdatePage } from "../features/VenueUpdatePage"
import EventsUpdate from "../features/EventsUpdate/EventsUpdate"
import TicketmasterCatalog from "../features/TicketmasterCatalog/TicketmasterCatalog"
import V2Pricing from "../features/V2Pricing/V2Pricing"
import { globalContext } from '../Provider/AppProvider';
import { useContext } from "react"
import AffiliateTransactions from "../features/Affiliate/AffiliateTransactions"
import PaymentInfo from "../components/shared-components/payment-info/PaymentInfo"
import { isSubscribeDomain, roles } from "../helper"
import EmailUnsubscribe from "../components/shared-components/email-unsubscribe/EmailUnsubscribe";
import EventUpdate from "../features/Eventupdate/EventUpdate"
import Setting from  "../features/Setting/AdminSettings"
import Affiliates from "../features/Affiliates/Affiliates"
import Salesrep from "../features/Salesrep/Salesrep"
import Addticket from "../features/Addticket/Addticket"
import Goals from "../features/Goals/goals"
import ManageTickets from "../features/ManageTickets/ManageTickets"
import TrendsPage from "../features/TrendsPage/TrendsPage"
import AnalyticsPage from "../features/Analytics/AnalyticsPage"
import Userdetails from "../features/Userdetails/Userdetails"
import AccessDenied from "../features/AccessDenied/AccessDenied";
import RolePageAccess from "../features/RolePageAccess/RolePageAccess";
import AdminAccess from "../features/AdminAccess/AdminAccess";
import { isPageAccessControlledRole, PATH_TO_PAGE_KEY, PERSONAL_PAGE_KEYS } from "../constants/pageAccess";
import AppUpdate from "../features/AppUpdate/AppUpdate";
import Auction from "../features/Auction/Auction";
export type navigationPropertiesTypes ={
    path: string,
    component: React.FC
}
type navigationType ={
    public : navigationPropertiesTypes[],
    private: navigationPropertiesTypes[]
}

export const useNavigation =()=>{
    const {globalState} = useContext<any>(globalContext);
    const currentRole = globalState.profile.userRole;

    const managedRoleRoutes: navigationPropertiesTypes[] = [
        { path: '/dashboard', component: AdminDashboard },
        { path: '/trends', component: TrendsPage },
        { path: '/goals', component: Goals },
        { path: '/managetickets', component: ManageTickets },
        { path: '/addticket', component: Addticket },
        { path: '/users', component: Users },
        { path: '/analytics', component: AnalyticsPage },
        { path: '/user/:userId', component: Userdetails },
        { path: '/salesrep', component: Salesrep },
        { path: '/affiliate', component: Affiliates },
        { path: '/affiliate/transactions/:id', component: AffiliateTransactions },
        { path: '/event-update', component: EventUpdate },
        { path: '/teamupdate', component: TeamUpdate },
        { path: '/venueupdate', component: VenueUpdatePage },
        { path: '/ticketmaster', component: TicketmasterCatalog },
        { path: '/setting', component: Setting },
        { path: '/auditLogs', component: AuditLogs },
        { path: '/profile', component: ProfileDetails },
    ];
    const subAdminManagedRoutes: navigationPropertiesTypes[] = [
        { path: '/dashboard', component: AdminDashboard },
        { path:'/trends', component:TrendsPage },
        { path:'/goals', component:Goals },
        { path:'/managetickets', component: ManageTickets },
        { path:'/addticket', component:Addticket },
        { path:'/users', component: Users },
        { path:'/analytics', component:AnalyticsPage },
        { path:'/user/:userId', component:Userdetails },
        { path:'/salesrep', component:Salesrep },
        { path : '/affiliate', component : Affiliates },
        { path : '/affiliate/transactions/:id', component : AffiliateTransactions },
        { path:'/event-update', component: EventUpdate },
        { path:'/teamupdate', component: TeamUpdate },
        { path:'/venueupdate', component: VenueUpdatePage },
        { path:'/ticketmaster', component:TicketmasterCatalog },
{ path : '/setting', component : Setting },
         { path:'/auditLogs', component: AuditLogs },
         { path:'/profile', component: ProfileDetails },
         { path : '/logs', component : ErrorDashboard },
         { path: '/app-update', component: AppUpdate },
         { path: '/app-version', component: AppUpdate },
     ];
    const affiliateAdminManagedRoutes: navigationPropertiesTypes[] = [
        ...managedRoleRoutes,
        { path: '/profile', component: ProfileDetails },
    ];

    /** Self-pricing / super_user on user.* — dashboard + Manage Tickets UI + profile (`/new-list` kept as alias URL) */
    const superUserRoutes: navigationPropertiesTypes[] = [
        { path: '/dashboard', component: AdminDashboard },
        { path: '/managetickets', component: ManageTickets },
        { path: '/new-list', component: ManageTickets },
        { path: '/profile', component: ProfileDetails },
    ];

    if (isSubscribeDomain()) {
        const navigation: navigationType = {
            public: [
                {
                path: '/unsubscribe',
                component: EmailUnsubscribe,
                },
            ],
            private: [],
        };
        return { navigation };
    }

    const navigation: navigationType = {
        public : [
            {
                path: '/login',
                component: SignIn
            },
            {
                path: '/forgot-password',
                component : ForgotPassword
            },
            {
                path: '/reset-password',
                component: ResetPassword
            },
            {
                path: '/paymentinfo',
                component: PaymentInfo
            },
            {
                path: '/auction',
                component: Auction
            }
        ],
        private: currentRole===roles.ADMIN  ? [
            {
                path: '/dashboard',
                component: AdminDashboard
            },
             {
                path:'/managetickets',
                component: ManageTickets
            },
            {
                path:'/users',
                component: Users
            },
            {
                path:'/profile',
                component: ProfileDetails
            },
            {
                path : '/affiliate',
                component : Affiliates
            },
            {
                path : '/affiliate/transactions/:id',
                component : AffiliateTransactions
            },
            {
                path : '/setting',
                component : Setting
            },
            {
                path: '/app-update',
                component: AppUpdate
            },
            {
                path: '/app-version',
                component: AppUpdate
            },
            {
                path : '/logs',
                component : ErrorDashboard
            },
            {
                path:'/auditLogs',
                component: AuditLogs
            },
            {
                path:'/events-update',
                component: EventsUpdate
            },
               {
                path:'/event-update',
                component: EventUpdate
            },
            {
                path:'/teamupdate',
                component: TeamUpdate
            },
            {
                path:'/venueupdate',
                component: VenueUpdatePage
            },
{
                 path:'/ticketmaster',
                 component: TicketmasterCatalog
             },
             {
                 path:'/app-version',
                 component: AppUpdate
             },
             {
                 path:'/pricing',
                 component: V2Pricing
             },
            {
                path:'salesrep',
                component:Salesrep
            },
               {
                path:'addticket',
                component:Addticket
            },
               {
                path:'goals',
                component:Goals
            },
             {
                path:'trends',
                component:TrendsPage
            },
             {
                path:'analytics',
                component:AnalyticsPage
            },
            {
                path:'user/:userId',
                component:Userdetails
            },
            {
                path:'/role-page-access',
                component: RolePageAccess
            },
            {
                path:'/admin-access',
                component: AdminAccess
            }
              
        ]:  currentRole===roles.AFFILIATER_ADMIN ? affiliateAdminManagedRoutes
        : currentRole===roles.SUPER_USER ? superUserRoutes
        : currentRole===roles.SUB_ADMIN ? subAdminManagedRoutes
        : currentRole===roles.MARKETING_USER ? managedRoleRoutes : [
        {
            path:'/tickets',
            component: Tickets
        },
        {
            path:'/profile',
            component: ProfileDetails
        },
        {
            path : '/settings',
            component : Setting
        },
        {
            path : '/logs',
            component : ErrorDashboard
        },]
    }

    const privateRoutes = navigation.private;
    const allowedPageKeys: string[] = globalState?.profile?.allowedPageKeys || [];

    const filteredPrivateRoutes = privateRoutes.filter((route) => {
        if (!isPageAccessControlledRole(currentRole)) {
            return true;
        }
        if (route.path === "/no-access") {
            return true;
        }
        const pageKey = PATH_TO_PAGE_KEY[route.path];
        if (!pageKey) {
            return false;
        }
        if (PERSONAL_PAGE_KEYS.includes(pageKey)) {
            return true;
        }
        return allowedPageKeys.includes(pageKey);
    });

    const hasNoAccessPage = filteredPrivateRoutes.some((route) => route.path === "/no-access");
    if (!hasNoAccessPage) {
        filteredPrivateRoutes.push({
            path: "/no-access",
            component: AccessDenied
        });
    }

    navigation.private = filteredPrivateRoutes;

    return {navigation}
}
